export const setBluetoothDevice = (device) => ({
    type: 'SET_BLUETOOTH_DEVICE',
    payload: device,
  });



